var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-page"},[_c('el-empty',{attrs:{"image-size":210,"description":"Welcome！欢迎使用救助信息后台管理系统！"}},[_c('p',[_vm._v("仓库地址：https://gitee.com/xuezihao/easvue_web")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }